import React from "react";
import { useTranslation } from "react-i18next";
import Image from "next/image";
import styled from "styled-components";
import BrowseFilesButton from "./BrowseFilesButton";
import { FileUploadProps } from "./FileUpload";
import { FileUploadContainer, Right, SecondaryText } from "./styled";
import imageIcon from "../../../../public/images/image-icon.png";
import { useFileDragAndDrop } from "../../../common/hooks/useFileDragAndDrop";

const StyledDescription = styled(SecondaryText)`
  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    text-align: center !important;
  }
`;

const StyledUpload = styled(FileUploadContainer)`
  padding-left: 50px;
  padding-right: 50px;
  justify-content: space-around;
  text-align: left;

  .right {
    flex-direction: column;
    p {
      margin-bottom: 8px;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    flex-direction: column;

    .right {
      p {
        margin: 8px 0;
      }
    }
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 131px;
  height: 98px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 93px;
    height: 69px;
  }
`;

const ImageUpload = ({
  fileFormats,
  name,
  error,
  isProcessing,
  ...inputProps
}: FileUploadProps) => {
  const { t } = useTranslation();
  const {
    eventHandlers,
    isDraggedOver,
    isFileUnknown,
    isFileInvalid,
    isFileValid,
  } = useFileDragAndDrop(fileFormats);

  return (
    <StyledUpload
      $isDragging={isDraggedOver}
      $unknown={isFileUnknown}
      $valid={isFileValid}
      $invalid={isFileInvalid}
      $error={error}
      {...eventHandlers}
    >
      <div className="left">
        <ImageWrapper>
          <Image src={imageIcon} layout="fill" />
        </ImageWrapper>
      </div>
      <Right className="right">
        <StyledDescription>
          {t("file-upload-drag-and-drop-here")}
        </StyledDescription>
        <BrowseFilesButton
          name={name}
          accept={fileFormats.join(",")}
          onChange={inputProps.onChange}
          isProcessing={isProcessing}
        />
      </Right>
    </StyledUpload>
  );
};

export default ImageUpload;
